import './styles/RowProblem.css'
import { useState } from 'react';
import mapboxgl from 'mapbox-gl';
import MenuAlert from './MenuAlert';
import InternalError from './generales/InternalError';
const RowProblem=(props)=>{
  // console.log(props)
  // const [infoShow,setInfoShow]=useState({severity:0,host:"",problem:"",ip:"",ack:"",ack_message:"",time:""})
  const [menuAlertOpen, setMenuAlertOpen] = useState(false);
  const [color, setColor] = useState('#43434d');
  const [ackMessage, setAckMessage] = useState('');
  
  // Garantizar que existan arrays para evitar errores de .some() o .includes()
  const poolRows = props.poolRows || [];
  const setPoolRows = props.setPoolRows || (() => {});
  const poolObjectRows = props.poolObjectRows || [];
  const setPoolObjectRows = props.setPoolObjectRows || (() => {});
  const filtraOrigen = props.filtraOrigen !== undefined ? props.filtraOrigen : true;
  // console.log(props.data)
  const openMenuAlert = () => {
// buscar_info(props.data.eventid)
    // console.log(props.origen)
    if(props.origen!='eventos' && props.origen!='to-do'){
      handleSelected(props.data)
    }
    
    // console.log(props.data.longitude)
    // console.log(props.ubicacion.groupid)
    // props.setUbicacion({latitud:props.data.latitude.replace(",", "."),longitud:props.data.longitude.replace(",", "."),zoom:16,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId: props.ubicacion.templateId})
    setMenuAlertOpen(true);
  };
  const handleSelected=(element)=>{
    if( element.latitude.replace(",", ".")>=-90 && element.latitude.replace(",", ".")<=90){
const coordinates=[element.longitude.replace(",", "."),element.latitude.replace(",", ".")]
// console.log(coordinates)
const popups = document.querySelectorAll('.custom-popup-findHost');
  
  popups.forEach(popup => {
//    console.log(popups)
  popup.remove();
  });
  props.mapAux.setZoom(12);
  props.mapAux.setCenter(coordinates);
    let popup = new mapboxgl.Popup({
        className: 'custom-popup-findHost',
        closeButton: true,
        closeOnClick: false
        })
        .setLngLat(coordinates)
        .setHTML(`<div class='cont-findHost' style='border: 1px solid #ffffff;'>
            <div class='findHost-txt'>${element.ip}</div>
            <div class='findHost-close' > </div>
            </div>`)
        .addTo(props.mapAux);
      }
  }
  const closeMenuAlert = () => {
    const popups = document.querySelectorAll('.custom-popup-findHost');
    popups.forEach(popup => {
      //    console.log(popups)
        popup.remove();
        });
    // if(props.ubicacion.groupid===0){
    //   // props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,zoom:6,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId: props.ubicacion.templateId})
    // }else{
    //   // props.setUbicacion({latitud:props.ubicacion.latitud,longitud:props.ubicacion.longitud,zoom:11,groupid:props.ubicacion.groupid,dispId:props.ubicacion.dispId,templateId: props.ubicacion.templateId})
    // }
    setMenuAlertOpen(false);
  };
  function cambiarFormatoFecha(fechaEnFormatoMMDDYYYY) {
    const partes = fechaEnFormatoMMDDYYYY.split('/');
    const fechaEnFormatoYYYYMMDD = `${partes[2]}-${partes[1]}-${partes[0]}`;
    return fechaEnFormatoYYYYMMDD;
  }
  const calcularDiferenciaTiempo = (fechaDada, horaDada) => {
    // Convertir la fecha y hora dadas a objetos Date
    // const fechaHoraDadas = new Date(`${cambiarFormatoFecha(fechaDada)}T${horaDada}`);
    const fechaHoraDadas = new Date(`${fechaDada}T${horaDada}`)
    // Obtener la fecha y hora actuales
    const fechaHoraActual = new Date();
    // Calcular la diferencia en milisegundos
    const diferenciaEnMilisegundos = fechaHoraDadas - fechaHoraActual;
    // Calcular la diferencia en minutos y horas
    const minutos = Math.floor(Math.abs(diferenciaEnMilisegundos) / (1000 * 60));
    const horas = Math.floor(minutos / 60);
    const dias =Math.floor(horas / 24);
    const txtHrs=horas-(dias*24)
    const txtMin=minutos-(horas*60)
    const response=((dias>=1)?dias+' dias ':'')+((txtHrs>=1)?txtHrs+' hrs ':'')+((txtMin>=1)?txtMin+' min':'0 min')
    return response;
  };
  const fechaDada = '2023-17-11';//2023-05-09
    const horaDada = '12:30:20';
    // const agencys={
    //   1:'cfe.png',
    //   2:'conagua.png',
    //   3:'cfe.png',
    //   8:'manto.png',

    // }
    const agencys={
      'cfe':'cfe.png',
      'con':'conagua.png',
      'imp':'implementacion.png',
      'man':'manto.png',
      
    }
    // const agencys_colors={
    //   1:'#00da19b7',
    //   2:'#00b7e1',
    //   3:'#00da19b7',
    //   8:'#c6124d',
    // }
    const agencys_colors={
      'cfe':'#00da19b7',
      'con':'#00b7e1',
      'imp':'#777',
      'man':'#c6124d',
    }
    function getImageById(id) {
      // console.log(props.dataAgencies.data.data)
      const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
      return agency ? agency.img : null;
    }
    function getImageByIdCriticitality(id) {
      // console.log(props.dataCriticalities.data.data)
      // console.log(id)
      const agency = props.dataCriticalities.data.data.find(element => element.level === id);
      return agency ? agency.icon : null;
    }
    function getColorById(id) {
      const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
      return agency ? agency.color : null;
    }
    const rowSelected = (elemento) => {
      setPoolRows((prevRows) => {
        const exists = prevRows.includes(elemento.eventid);
        if (exists) {
          return prevRows.filter(eventid => eventid !== elemento.eventid);
        } else {
          return [...prevRows, elemento.eventid];
        }
      });
      setPoolObjectRows((prevRows) => {
        const exists = prevRows.includes(elemento.eventid);
        if (exists) {
          return prevRows.filter(eventid => eventid !== elemento.eventid);
        } else {
          return [...prevRows, elemento];
        }
      });
    };
    const clickRow=()=>{
      if(menuAlertOpen){
        closeMenuAlert()
      }else{
        openMenuAlert()
      }
      // closeMenuAlert:openMenuAlert
    }
    function formatDuration(text) {
      const parts = text.split(' ');
      const result = [];
    
      for (let i = 0; i < parts.length; i += 2) {
        const value = parseInt(parts[i], 10);
        const label = parts[i + 1];
    
        if (label.includes('min') || value !== 0) {
          result.push(`${value} ${label}`);
        }
      }
    
      return result.join(' ');
    }
    // const [poolRows,setPoolRows]=useState([])
    // const [poolObjectRows,setPoolObjectRows]=useState([])
    // console.log(poolRows)
    try {
      
    
    return(
      <>
      
      {
      ( (props.data.tipo == 1 || (props.data.tipo == 0 && filtraOrigen == false))) ?
      // (  props.data.Estatus!="RESOLVED" && (props.data.severity==6 && props.data.tipo==1 ) || (props.data.severity!==6 ) )?
      // (true)?
      
        <tr className="ev-table-row" onClick={() => clickRow()}>
            <td>
                <input 
                    type="checkbox" 
                    checked={poolRows.some((row) => row === props.data.eventid)}
                    onChange={(e) => {
                        e.stopPropagation();
                        rowSelected(props.data);
                    }}
                    onClick={(e) => e.stopPropagation()}
                />
            </td>
            <td>
                <div className={`sev-pill s${props.data.severity}`}>
                    S-{props.data.severity}
                </div>
            </td>
            <td>
                <div className="ev-link" title={props.data.Problem}>
                    {props.data.Problem.length > 30 ? `${props.data.Problem.slice(0, 30)}...` : props.data.Problem}
                </div>
            </td>
            <td>
                <div className="ev-link" style={{color: '#6b7280'}}>
                    {props.data.Host}
                </div>
            </td>
            <td>
                <div className={`status-pill ${props.data.Estatus === 'RESOLVED' ? 'resolved' : 'problem'}`}>
                    {props.data.Estatus}
                </div>
            </td>
            <td className="txt-futuristic">{props.data.tipo}</td>
            <td className="txt-futuristic" style={{fontWeight: '700'}}>{props.data.dependents}</td>
            <td>
                <div className={`ack-dot ${props.data.acknowledges_concatenados ? 'active' : ''}`}></div>
            </td>
            <td>
                {(props.data.ticket_id || props.data.ticket_status) ? (
                    <div className="ack-dot active" style={{background: props.data.ticket_status === 'creado' ? '#10b981' : (props.data.ticket_status === 'error' ? '#ef4444' : '#f59e0b')}}></div>
                ) : (
                    <span style={{color: '#d1d5db'}}>—</span>
                )}
            </td>
            <td className="txt-futuristic">{props.data.sla || "N/A"}</td>
            <td className="txt-futuristic">
                {calcularDiferenciaTiempo(cambiarFormatoFecha(props.data.Time.slice(0, 10)), props.data.Time.slice(-8))}
            </td>
            <td className="txt-futuristic">{props.data.Time.slice(0, 10)}</td>
            <td className="txt-futuristic" style={{color: props.data.Estatus === 'RESOLVED' ? '#10b981' : 'inherit'}}>
                {(props.data.Estatus === 'RESOLVED' && props.data.recovered_at.length > 5) ? props.data.recovered_at.slice(-8) : props.data.Time.slice(-8)}
            </td>
        </tr>
    : ''}
    {menuAlertOpen && (
        <tr className="ev-expand-row">
            <td colSpan="13" style={{padding: '0', background: '#f9fafb'}}>
                <MenuAlert 
                    languaje={props.languaje} 
                    setImportModalOpen={props.setImportModalOpen} 
                    setSuveryId={props.setSuveryId} 
                    handleShowPopup={props.handleShowPopup} 
                    setSearchTerm={props.setSearchTerm} 
                    ubiActual={props.ubiActual} 
                    search_problems={props.search_problems} 
                    server={props.server} 
                    ackMessage={ackMessage} 
                    setAckMessage={setAckMessage}
                    isOpen={menuAlertOpen} 
                    props={props} 
                    onClose={closeMenuAlert} 
                />
            </td>
        </tr>
    )}
      
      </>
    )
  } catch (error) {
      <InternalError></InternalError>
  }
}
export default RowProblem